module.exports = __webpack_public_path__ + "static/media/32.b8e29195.jpeg";